import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=08ec9f98&"
import script from "./UserEditDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ec9f98')) {
      api.createRecord('08ec9f98', component.options)
    } else {
      api.reload('08ec9f98', component.options)
    }
    module.hot.accept("./UserEditDetails.vue?vue&type=template&id=08ec9f98&", function () {
      api.rerender('08ec9f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/users/views/UserEditDetails.vue"
export default component.exports